// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-blue-haven -> weidner-apartment-homes-theme-blue-haven -> mckinney-village
// Generated: 2026-11-03T22:26:52.819Z
// Counts: 3 design, 19 content, 22 slot group, 0 collection binding, 8 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.secondary": {
    "cssVariable": "--vibe-color-secondary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "discoveramenities.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Get to <span data-type=\"field-token\" data-field=\"property_name\"></span>?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for <br>Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "tabbedcallouts.section_heading": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Find Your Space</strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourintro.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "future-residents-club-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>We don't just rent apartments. From the moment you walk through the front door you'll feel the comfort and serenity that makes our residents happy to call us home. Thoughtful amenities, well groomed grounds, and a dedicated staff all contribute to a higher standard of living. Whether you are waiting to move next year, or waiting for the perfect floor plan, we have a special program for you.</p><p>Join the Future Residents C﻿lub and reserve your spot now!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 18px;\">All applicants are required to create a profile with PetScreening.</span><span><br></span></p><p><span style=\"font-size: 18px;\">Applicants without pets will confirm there will be no pets in the household.</span><span>﻿</span></p><p><span style=\"font-size: 18px;\">Applicants with service/support animals will provide documentation for legal review.</span></p><p><span style=\"font-size: 18px;\"><br></span></p><p><span style=\"font-size: 18px;\">Applicants with pets will pay $25 to register each pet. A photo of your pet(s), information, and other documentation must be provided.</span></p><p><span><br></span></p><p><strong>PET POLICIES</strong></p><p><span style=\"font-size: 18px;\">We allow dogs, cats, birds, fish, gerbils, and hamsters. We permit up to 2 dogs or cats and have no weight restrictions.</span></p><p><span><br></span></p><p><span style=\"font-size: 18px;\">Approved applicants with pets will be required to pay a non-refundable one-time pet fee for each pet and may be required to pay a pet deposit.</span></p><p><span><br></span></p><p><span style=\"font-size: 18px;\">Monthly pet rent for dogs and cats will be included in the lease. The monthly pet rent will be determined by the review of information and documentation provided in the pet screening profile.&nbsp;</span></p><p><span><br></span></p><p><span style=\"font-size: 18px;\">Service/Support animals are not considered pets.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 18px;\">Breed restrictions include:</span></p><ul><li><p><span style=\"font-size: 18px;\">Pit Bulls, Bull Terriers</span></p></li><li><p><span style=\"font-size: 18px;\">American Staffordshire Terriers</span></p></li><li><p><span style=\"font-size: 18px;\">Rottweilers</span></p></li><li><p><span style=\"font-size: 18px;\">German Shepherds</span></p></li><li><p><span style=\"font-size: 18px;\">Dobermans</span></p></li><li><p><span style=\"font-size: 18px;\">Chows</span></p></li><li><p><span style=\"font-size: 18px;\">Presa Canarios</span></p></li><li><p><span style=\"font-size: 18px;\">Akitas</span></p></li><li><p><span style=\"font-size: 18px;\">Wolf Hybrid</span></p></li><li><p><span style=\"font-size: 18px;\">Huskies</span></p></li></ul><p><span style=\"font-size: 18px;\">This applies to full or partial breeds.</span></p><p></p><p><span style=\"font-size: 18px;\">We reserve the right to amend the breed restrictions at any time we deem necessary.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>The studio layout makes the most of every square foot, pairing a well-appointed island kitchen with an open living space that flows effortlessly. Soaring 9' to 10' ceilings, a spacious closet, and abundant natural light give this efficient home a bright, airy feel — ideal for easy, low-maintenance living.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>This one-bedroom home centers on a gourmet island kitchen with quartz countertops and stainless-steel appliances, opening to a comfortable living and dining area. A private bedroom with a ceiling fan and generous closet — plus your own <a href=\"/amenities\">balcony or patio</a> — makes it a relaxed retreat for everyday living.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>A roomier one-bedroom layout offers a bright, open living area anchored by a modern kitchen with pendant lighting and a spacious pantry. The oversized bedroom and walk-in closet give you plenty of space to spread out, while large windows keep the home feeling warm and inviting.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel4_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>The two-bedroom floor plan delivers the most room to live, with an expansive open-concept kitchen and living space made for gathering and entertaining. Two well-proportioned bedrooms, dual baths, and thoughtful storage throughout create a comfortable home for roommates or families. Explore all our <a href=\"/floor-plans\">floor plans</a> to find the right fit.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019ff64a-2122-71af-94e2-9937f73399cc.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman petting a small dog on a cozy couch, enjoying a relaxing moment at home."
      }
    }
  },
  "amenitiesfeatures.apartmentBannerImage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-c5f1-7245-8a96-9762be965209.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept apartment kitchen and living area with island, dark cabinets, and stainless-steel appliances."
      }
    }
  },
  "amenitiesfeatures.communityBannerImage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-9a8e-72ea-908b-61304aa57d99.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright modern apartment lobby with white walls, high ceilings, and a seating area of leather couches."
      }
    }
  },
  "amenitiesintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-a7c9-737d-ae4c-c53a1fcf067e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor community pool with lounge chairs and planters at an apartment complex."
      }
    }
  },
  "amenitieslist.card0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Business Center"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166786/019d01ae-8aa3-72de-b545-57f6c06bb226.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community business center with two computer stations and comfortable seating."
      }
    }
  },
  "amenitieslist.card1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-7291-7685-8223-c59b57e0f039.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious modern community lounge with seating areas, a long reception desk, and wall decor."
      }
    }
  },
  "amenitieslist.card2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Elevator"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166786/019d01ae-9a8c-71c7-8f01-e48d3fe3682a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Stylish and comfortable seating area in the apartment lobby with elegant sofas and chairs."
      }
    }
  },
  "amenitieslist.card3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Lounge"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166786/019d01ae-9a8e-72ea-908b-61304aa57d99.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious lounge area with multiple seating options, a bar, and a television."
      }
    }
  },
  "amenitieslist.card4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Grill"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-7e5b-7208-b16b-2478438e263e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor brick patio with wicker seating and built-in grills."
      }
    }
  },
  "amenitieslist.card5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-8d2e-7438-ac97-eadb1d5b4f94.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior view of a residential gym with cardio machines and weight equipment."
      }
    }
  },
  "amenitieslist.card6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-a852-7055-88cb-de8d15aa9769.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pool area with white pergola, lounge chairs, and planters"
      }
    }
  },
  "amenitieslist.card7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "*Garages and Carports Available"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166786/019d01ae-99cb-714c-bac8-86315910448b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "McKinney Village building exterior with signage and parking lot."
      }
    }
  },
  "dallasmavericksgames.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://mavs.spinzo.com/?group=corporate-group-offers-f6xp&affiliate=mckinney-village-6vh2"
      }
    }
  },
  "discoveramenities.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-8d2e-7438-ac97-eadb1d5b4f94.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior view of a residential gym with cardio machines and weight equipment."
      }
    }
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "fullbleedstripe.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-b543-71a0-abcc-5c506956f7ce.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor community courtyard with planters, trees, and benches in a residential complex."
      }
    }
  },
  "propertyoverview.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-a852-7055-88cb-de8d15aa9769.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pool area with white pergola, lounge chairs, and planters"
      }
    }
  },
  "tabbedcallouts.panel1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-b6df-70ac-af1f-49b3dec8e687.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright apartment living room with white sofa, teal armchair, and large windows."
      }
    }
  },
  "tabbedcallouts.panel2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-d067-741e-b329-c7d9bbf64845.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with dark cabinets, stainless appliances, and a marble island with seating."
      }
    }
  },
  "tabbedcallouts.panel3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-b9e9-768f-b28e-208cff768da4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen bed, gray tufted headboard, two mirrored nightstands, and large windows with blinds."
      }
    }
  },
  "tabbedcallouts.panel4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166786/019d01ae-c5f1-7245-8a96-9762be965209.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept apartment kitchen and living area with island, dark cabinets, and stainless-steel appliances."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
